export const PRODUCT_CONDITION_OPTIONS = [
  { value: 'new', translationKey: 'conditions.new' },
  { value: 'used', translationKey: 'conditions.used' }
];

export const getProductConditionTranslationKey = (condition) => {
  return PRODUCT_CONDITION_OPTIONS.find((option) => option.value === condition)?.translationKey || 'conditions.unknown';
};